import { render, staticRenderFns } from "./PracticeSkill.vue?vue&type=template&id=4251f77f&scoped=true&"
import script from "./PracticeSkill.vue?vue&type=script&lang=js&"
export * from "./PracticeSkill.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSkill.vue?vue&type=style&index=0&id=4251f77f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251f77f",
  null
  
)

export default component.exports